export default __webpack_public_path__ + "icon42a7283.svg";